import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { Paragraph } from '@atoms'
import { Dialog } from '@organisms'
import { BridgeService } from '@services/bridge'
import Tag from '@utils/Tag'
import { ApplicationState } from '@store/types'

import { VariantDialogContratos } from './dialogVariants'

interface Props {
  setShowBottomSheet: React.Dispatch<React.SetStateAction<boolean>>
  variant: VariantDialogContratos
  customTextButton?: string
  customActionButton?: () => void
}

const BottomsheetCustom = ({
  setShowBottomSheet,
  variant,
  customTextButton,
  customActionButton,
}: Props) => {
  const { convenioName } = useSelector((state: ApplicationState) => state.refinanciamento.contratos)
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  useEffect(() => {
    BridgeService.tac({
      name: 'bottomsheet_contratos',
      actions: ['abrir_bottomsheet_contratos'],
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:bottomsheet',
        ref_type: 'botao',
        content_action: 'Toque',
        action_id: 'Abrir',
        product: convenioName,
        section: 'bottomsheet',
        sub_section: '',
        step: '',
        scenario: '',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'click button',
        element_name: 'Abrir',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'PayrollLoan:Refin:Bottomsheet',
        section: 'Bottomsheet',
        sub_section: '',
        step: '',
        scenario: '',
      })
    }
  }, [variant.title, convenioName, isApp])

  const handleClose = () => {
    BridgeService.tic({
      name: 'btn_fechar_contratos',
      action: 'fechar_bottomsheet_contratos',
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:bottomsheet',
        ref_type: 'botao',
        content_action: 'Toque',
        action_id: 'Fechar',
        product: convenioName,
        section: 'bottomsheet',
        sub_section: '',
        step: '',
        scenario: '',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'click button',
        element_name: 'Fechar',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'PayrollLoan:Refin:Bottomsheet',
        section: 'Bottomsheet',
        sub_section: '',
        step: '',
        scenario: '',
      })
    }

    setShowBottomSheet(false)
  }

  const handleButtonAction = () => {
    BridgeService.tic({
      name: 'btn_acao_contratos',
      action: 'acao_bottomsheet_contratos',
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:bottomsheet',
        ref_type: 'botao',
        content_action: 'Toque',
        action_id: 'Continuar',
        product: convenioName,
        section: 'bottomsheet',
        sub_section: '',
        step: '',
        scenario: '',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'click button',
        element_name: 'Continuar',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'PayrollLoan:Refin:Bottomsheet',
        section: 'Bottomsheet',
        sub_section: '',
        step: '',
        scenario: '',
      })
    }

    if (customActionButton) {
      customActionButton()
    } else {
      setShowBottomSheet(false)
    }
  }

  return (
    <Dialog
      onClose={handleClose}
      headerTitle={variant.title}
      buttonText={customTextButton || 'Entendi'}
      buttonAction={handleButtonAction}
    >
      <Paragraph margin="0 0 20px 0">{variant.text}</Paragraph>
    </Dialog>
  )
}

export default BottomsheetCustom
